import { SelectSearchOption } from "react-select-search";

export const getMinQuantity = (prepId: number) => {
  if(prepId === 265180) return 5;
  return 1;
} 

export const round = (price: number) => {
  return +price.toFixed(2);
}

export const beautyPrice = (price: number) => {
  return price.toLocaleString().replace(',', '.');
}

export const getMaxQuantity = (maxQuantity?: number, prepId?: number) => {
  const maxQuantityDefault = 10;
  if(prepId === 265180) return maxQuantity ? maxQuantity : 5000;

  if(maxQuantity && maxQuantity < maxQuantityDefault) return maxQuantity;
  return maxQuantityDefault;
}

export const getQuantityStep = (prepId?: number) => {
  const stepDefault = 1;
  if(prepId === 265180) return 5;
  return stepDefault;
}

export const removeDistrict = (address: string) => {
  if(address.substring(0, 2).toLowerCase() === 'г.') return address;
  return address.split(',').slice(1).join(',');
}

export function optionsSearch(options: SelectSearchOption[]) {
  return (query: string) => {
    return options.filter(item => item.name.toLowerCase().includes(query.toLowerCase()))
  }
}

export function getBlockedText(type: number) {
  switch (+type) {
    case 1:
      return 'Для покупки(заказа) товара необходимо обратиться в аптеку'
    case 2:
      return 'Под заказ'
    default:
      return 'Для заказа товара необходимо обратиться в аптеку'
    
  }
}